import { render, staticRenderFns } from "./SetupModuleCard.vue?vue&type=template&id=4ea08817&scoped=true&"
import script from "./SetupModuleCard.vue?vue&type=script&lang=js&"
export * from "./SetupModuleCard.vue?vue&type=script&lang=js&"
import style0 from "./SetupModuleCard.vue?vue&type=style&index=0&id=4ea08817&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea08817",
  null
  
)

export default component.exports